// extracted by mini-css-extract-plugin
module.exports = {"wrap":"IconsSocial_wrap__3TAJa"};